export default "__VITE_ASSET__e36160dc__$_?nuxt_component=async__"